module.exports = __webpack_public_path__ + "img/logo_sm.e2e43aa4.png";